import { render, staticRenderFns } from "./bills.vue?vue&type=template&id=10b9ccbb&scoped=true&"
import script from "./bills.vue?vue&type=script&lang=js&"
export * from "./bills.vue?vue&type=script&lang=js&"
import style0 from "./bills.vue?vue&type=style&index=0&id=10b9ccbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b9ccbb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10b9ccbb')) {
      api.createRecord('10b9ccbb', component.options)
    } else {
      api.reload('10b9ccbb', component.options)
    }
    module.hot.accept("./bills.vue?vue&type=template&id=10b9ccbb&scoped=true&", function () {
      api.rerender('10b9ccbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/user/profile/tabs/billing_components/bills.vue"
export default component.exports